import { DocumentNode } from "graphql";
import { gql } from "@apollo/client";

export const wait = (seconds: number): Promise<string> =>
  new Promise((resolve) => {
    setTimeout(() => {
      resolve("timer klar");
    }, seconds * 1000);
  });

export const uuid = (): string =>
  "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    // eslint-disable-next-line no-bitwise
    const r = (Math.random() * 16) | 0;
    // eslint-disable-next-line no-bitwise
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });

export const formatNumber = (number: number): string => {
  return new Intl.NumberFormat("sv-SE").format(number);
};

export const capitalizeFirstLetter = (string: string): string => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const SHA256 = async (text: string): Promise<string> => {
  const msgUint8 = new TextEncoder().encode(text);
  const hashBuffer = await crypto.subtle.digest("SHA-256", msgUint8);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
};

export const toCamelCase = (string: string): string =>
  string
    .toLowerCase()
    .replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());

export const toPascalCase = (string: string): string =>
  toCamelCase(string).charAt(0).toUpperCase() + toCamelCase(string).slice(1);

export const toFirstLetterUpperCase = (string: string): string =>
  string.charAt(0).toUpperCase() + string.slice(1);

export const getAppUrl: () => string = () => {
  const ua = navigator.userAgent.toLowerCase();
  const isAndroid = ua.indexOf("android") > -1;
  if (isAndroid) {
    return "https://play.google.com/store/apps/details?id=com.teamlassie.lassieapp";
  }
  return "https://apps.apple.com/se/app/lassie/id1533808157";
};

export function gqlArray(fragmentArray: DocumentNode[]) {
  const str = new Array(fragmentArray.length + 1).fill("");

  // @ts-ignore
  str.raw = str;
  return gql(str, ...fragmentArray);
}

export const websiteLocale = (locale: string) => locale.replace("-", "_");

export function isLocalStorageAvailable() {
  const test = "test";
  try {
    window.localStorage.setItem(test, test);
    window.localStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
}

export function isSessionStorageAvailable() {
  const test = "test";
  try {
    window.sessionStorage.setItem(test, test);
    window.sessionStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
}
